import RequestAbstract from "../abstract";

export default class ExternalTransactions extends RequestAbstract {
    data;

    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/external-transactions";
    }
}